"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCells = void 0;
const currency_label_1 = require("@components/currency-label");
const expandable_grid_1 = require("@shared-modules/components/expandable-grid");
const object_1 = require("@utils/object");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const getCells = (translator, tokens) => {
    return [
        {
            id: "number",
            title: "#",
            size: "60px",
            type: expandable_grid_1.ItemTypes.String,
            render: ({ rank }) => rank,
        },
        {
            id: "name",
            title: translator("userColumnLabel"),
            size: 1,
            type: expandable_grid_1.ItemTypes.String,
            render: ({ user }) => (react_1.default.createElement("div", { className: "c-rating-page-users-rating-grid__user" },
                react_1.default.createElement("img", { src: user.avatar }),
                react_1.default.createElement("div", { className: "c-rating-page-users-rating-grid__user-name" },
                    (0, object_1.concatStringsWithWhitespace)(user.firstName, user.lastName),
                    react_1.default.createElement(react_router_dom_1.Link, { className: "c-rating-page-users-rating-grid__user-link g-link", target: "_blank", to: `/profile/${user.wallet}` }, (0, object_1.formatAddress)(user.wallet))))),
        },
        {
            id: "deals",
            title: translator("dealsColumnLabel"),
            size: "80px",
            type: expandable_grid_1.ItemTypes.Number,
            render: ({ dealsAmount }) => dealsAmount,
        },
        ...tokens.map(({ symbol, address }) => ({
            id: "token" + address,
            title: react_1.default.createElement(currency_label_1.CurrencyLabel, { tokenAddress: address }),
            size: "130px",
            type: expandable_grid_1.ItemTypes.Number,
            render: ({ tradeVolumes }) => {
                var _a;
                return (react_1.default.createElement(currency_label_1.CurrencyLabel, { tokenAddress: address, isNormalized: false, amount: ((_a = tradeVolumes.find(({ paymentTokenAddress }) => (0, object_1.caseInsensitiveCompare)(paymentTokenAddress, address))) === null || _a === void 0 ? void 0 : _a.volume) || 0 }));
            },
        })),
    ];
};
exports.getCells = getCells;
